import React from 'react';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { createRouter } from '@uhg-abyss/web/tools/createRouter';
import { AbyssProvider } from '@uhg-abyss/web/ui/AbyssProvider';
import { Routes } from './routes';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { RouterProvider } from '@uhg-abyss/web/ui/RouterProvider';

const theme = createTheme('uhc');
const router = createRouter(Routes);

export const browser = () => {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} children={undefined} />
    </ThemeProvider>
  );
};
